import enMessages from '../../../i18n/form/en.js';
import ruMessages from '../../../i18n/form/ru.js';

export const MESSAGES = {
    en: enMessages,
    ru: ruMessages,
};
export const CODE_LENGTH = 6;

export const TIMER_TIMEOUT_MS = 1000;
